<template>
  <b-row class="my-3">
    <b-col cols="12">
      <h4><b>Jobs Filter</b></h4>
      <p>Select jobs by department and/or location</p>
      <advanced-form :form="formFields" v-bind="form" v-model="form" :hideFormControl="true" />
    </b-col>
    <b-col cols="12">
      <b-button @click="updateFilters">Update Filters</b-button>
    </b-col>
  </b-row>
</template>

<script>
import CampaignAnalyticsFilterQuery from '@/graphql/queries/CampaignAnalyticsFilter.gql';
import AdvancedForm from '@src/components/AdvancedForm';
import { mapRoot } from '@src/mixins/root';

export default {
  name: 'CampaignAnalyticsFilter',
  props: {
    value: {
      type: Object,
    }
  },
  components: {
    AdvancedForm
  },
  data: () => ({
    form: {},
  }),
  apollo: {
    api: {
      query: CampaignAnalyticsFilterQuery,
      update({ company }) {
        return company;
      },
      fetchPolicy: 'network-only'
    },
  },
  created() {
    // Set segment form
    const { value } = this;
    if (!value) return;
    const { AND } = value;
    if (!Array.isArray(AND) || !AND.length) return;
    this.form = AND.reduce((r, { departments, NOT, OR }) => {
      if (departments) {
        const { id_in: idIn } = departments;
        r.departments = idIn;
        return r;
      } else if (NOT && NOT.length) {
        const { id_in: idIn } = NOT[0];
        this.notIDs = idIn;
        return r;
      } else if (Array.isArray(OR) && OR.length && OR[0].customFields &&
        Array.isArray(OR[0].customFields) && OR[0].customFields.length) {
        if (OR[0].customFields[0].key === 'location') {
          r.locations = OR.map(({ customFields }) => {
            const [ customField ] = customFields;
            return customField.key === 'location' ? customField.value : null;
          }).filter(el => el);
          return r;
        } else if (OR[0].customFields[0].key === 'brands') {
          r.brands = OR.map(({ customFields }) => {
            const [ customField ] = customFields;
            return customField.key === 'brands' ? customField.value : null;
          }).filter(el => el);
          return r;
        } else if (OR[0].customFields[0].key === 'region') {
          r.regions = OR.map(({ customFields }) => {
            const [ customField ] = customFields;
            return customField.key === 'region' ? customField.value : null;
          }).filter(el => el);
          return r;
        } else if (OR[0].customFields[0].key === 'district') {
          r.districts = OR.map(({ customFields }) => {
            const [ customField ] = customFields;
            return customField.key === 'district' ? customField.value : null;
          }).filter(el => el);
          return r;
        } else if (OR[0].customFields[0].key === 'city') {
          r.cities = OR.map(({ customFields }) => {
            const [ customField ] = customFields;
            return customField.key === 'city' ? customField.value : null;
          }).filter(el => el);
          return r;
        } else if (OR[0].customFields[0].key === 'country') {
          r.countries = OR.map(({ customFields }) => {
            const [ customField ] = customFields;
            return customField.key === 'country' ? customField.value : null;
          }).filter(el => el);
          return r;
        } else if (OR[0].customFields[0].key === 'postalDistrict') {
          r.postalDistricts = OR.map(({ customFields }) => {
            const [ customField ] = customFields;
            return customField.key === 'postalDistrict' ? customField.value : null;
          }).filter(el => el);
          return r;
        } else if (OR[0].customFields[0].key === 'jobTitle') {
          r.jobTitles = OR.map(({ customFields }) => {
            const [ customField ] = customFields;
            return customField.key === 'jobTitle' ? customField.value : null;
          }).filter(el => el);
          return r;
        } else if (OR[0].customFields[0].key === 'activity') {
          r.activities = OR.map(({ customFields }) => {
            const [ customField ] = customFields;
            return customField.key === 'activity' ? customField.value : null;
          }).filter(el => el);
          return r;
        } else if (OR[0].customFields[0].key === 'chain') {
          r.chains = OR.map(({ customFields }) => {
            const [ customField ] = customFields;
            return customField.key === 'chain' ? customField.value : null;
          }).filter(el => el);
          return r;
        } else if (OR[0].customFields[0].key === 'area') {
          r.areas = OR.map(({ customFields }) => {
            const [ customField ] = customFields;
            return customField.key === 'area' ? customField.value : null;
          }).filter(el => el);
          return r;
        } else if (OR[0].customFields[0].key === 'company') {
          r.companies = OR.map(({ customFields }) => {
            const [ customField ] = customFields;
            return customField.key === 'company' ? customField.value : null;
          }).filter(el => el);
          return r;
        } else if (OR[0].customFields[0].key === 'jobPosition') {
          r.jobPositions = OR.map(({ customFields }) => {
            const [ customField ] = customFields;
            return customField.key === 'jobPosition' ? customField.value : null;
          }).filter(el => el);
          return r;
        } else if (OR[0].customFields[0].key === 'callCenter') {
          r.callCenters = OR.map(({ customFields }) => {
            const [ customField ] = customFields;
            return customField.key === 'callCenter' ? customField.value : null;
          }).filter(el => el);
          return r;
        } else if (OR[0].customFields[0].key === 'office') {
          r.offices = OR.map(({ customFields }) => {
            const [ customField ] = customFields;
            return customField.key === 'office' ? customField.value : null;
          }).filter(el => el);
          return r;
        } else if (OR[0].customFields[0].key === 'organisation') {
          r.organisations = OR.map(({ customFields }) => {
            const [ customField ] = customFields;
            return customField.key === 'organisation' ? customField.value : null;
          }).filter(el => el);
          return r;
        }
      }
    }, {});
  },
  computed: {
    ...mapRoot([ 'company', 'user', 'isRecruiter', 'isRecruiterAdmin', 'isProd', 'isEXPD8', 'isKP', 'isChalhoub' ]),
    segment() {
      const { form } = this;
      const {
        activities,
        areas,
        brands,
        callCenters,
        chains,
        cities,
        companies,
        countries,
        departments,
        districts,
        jobPositions,
        jobTitles,
        locations,
        offices,
        organisations,
        postalDistricts,
        regions,
      } = form || {};

      if ((!Array.isArray(departments) || !departments.length) &&
        (!Array.isArray(locations) || !locations.length) &&
        (!Array.isArray(brands) || !brands.length) &&
        (!Array.isArray(regions) || !regions.length) &&
        (!Array.isArray(districts) || !districts.length) &&
        (!Array.isArray(cities) || !cities.length) &&
        (!Array.isArray(countries) || !countries.length) &&
        (!Array.isArray(postalDistricts) || !postalDistricts.length) &&
        (!Array.isArray(jobTitles) || !jobTitles.length) &&
        (!Array.isArray(activities) || !activities.length) &&
        (!Array.isArray(areas) || !areas.length) &&
        (!Array.isArray(companies) || !companies.length) &&
        (!Array.isArray(jobPositions) || !jobPositions.length) &&
        (!Array.isArray(callCenters) || !callCenters.length) &&
        (!Array.isArray(offices) || !offices.length) &&
        (!Array.isArray(organisations) || !organisations.length) &&
        (!Array.isArray(chains) || !chains.length)) {
        return null;
      }

      const AND = [];
      if (Array.isArray(departments) && departments.length) {
        AND.push({ departments: { id_in: departments } });
      }
      if (Array.isArray(locations) && locations.length) {
        AND.push({ OR: locations.map(value => ({ customFields: [ { key: 'location', value } ] })) });
      }
      if (Array.isArray(brands) && brands.length) {
        AND.push({ OR: brands.map(value => ({ customFields: [ { key: 'brands', value } ] })) });
      }
      if (Array.isArray(regions) && regions.length) {
        AND.push({ OR: regions.map(value => ({ customFields: [ { key: 'region', value } ] })) });
      }
      if (Array.isArray(districts) && districts.length) {
        AND.push({ OR: districts.map(value => ({ customFields: [ { key: 'district', value } ] })) });
      }
      if (Array.isArray(cities) && cities.length) {
        AND.push({ OR: cities.map(value => ({ customFields: [ { key: 'city', value } ] })) });
      }
      if (Array.isArray(countries) && countries.length) {
        AND.push({ OR: countries.map(value => ({ customFields: [ { key: 'country', value } ] })) });
      }
      if (Array.isArray(postalDistricts) && postalDistricts.length) {
        AND.push({ OR: postalDistricts.map(value => ({ customFields: [ { key: 'postal-district', value } ] })) });
      }
      if (Array.isArray(jobTitles) && jobTitles.length) {
        AND.push({ OR: jobTitles.map(value => ({ customFields: [ { key: 'job-title', value } ] })) });
      }
      if (Array.isArray(activities) && activities.length) {
        AND.push({ OR: activities.map(value => ({ customFields: [ { key: 'activity', value } ] })) });
      }
      if (Array.isArray(chains) && chains.length) {
        AND.push({ OR: chains.map(value => ({ customFields: [ { key: 'chain', value } ] })) });
      }
      if (Array.isArray(areas) && areas.length) {
        AND.push({ OR: areas.map(value => ({ customFields: [ { key: 'area', value } ] })) });
      }
      if (Array.isArray(companies) && companies.length) {
        AND.push({ OR: companies.map(value => ({ customFields: [ { key: 'company', value } ] })) });
      }
      if (Array.isArray(jobPositions) && jobPositions.length) {
        AND.push({ OR: jobPositions.map(value => ({ customFields: [ { key: 'job-position', value } ] })) });
      }
      if (Array.isArray(callCenters) && callCenters.length) {
        AND.push({ OR: callCenters.map(value => ({ customFields: [ { key: 'call-center', value } ] })) });
      }
      if (Array.isArray(offices) && offices.length) {
        AND.push({ OR: offices.map(value => ({ customFields: [ { key: 'office', value } ] })) });
      }
      if (Array.isArray(organisations) && organisations.length) {
        AND.push({ OR: organisations.map(value => ({ customFields: [ { key: 'organisation', value } ] })) });
      }

      return { AND };
    },
    returnSegment() {
      const { segment } = this;
      if (!segment) return null;
      const result = { ...segment };
      return result;
    },
    formFields() {
      const { departments, jobAggs } = this.api || {};
      const {
        activity,
        area,
        brand,
        callCenter,
        chain,
        city,
        company,
        country,
        district,
        jobPosition,
        jobTitle,
        location,
        office,
        organisation,
        postalDistrict,
        region,
      } = jobAggs || {};
      return {
        ...(!this.isEXPD8 && !this.isKP && Array.isArray(departments) && departments.length ? {
          departments: {
            label: this.$t('campaign-admin.labels.departments'),
            type: 'MULTISELECT',
            choices: departments.filter(item => item).reduce((r, { id, name }) => ({ ...r, [id]: name }), {}),
          },
        } : {}),
        ...(!this.isEXPD8 && Array.isArray(location) && location.length ? {
          locations: {
            label: this.$t('campaign-admin.labels.locations'),
            type: 'MULTISELECT',
            choices: location.reduce((r, el) => ({ ...r, [el]: el }), {}),
          },
        } : {}),
        ...(Array.isArray(brand) && brand.length ? {
          brands: {
            label: this.$t('campaign-admin.labels.brands'),
            type: 'MULTISELECT',
            choices: brand.reduce((r, el) => ({ ...r, [el]: el }), {}),
          },
        } : {}),
        ...(Array.isArray(region) && region.length ? {
          regions: {
            label: this.$t('campaign-admin.labels.regions'),
            type: 'MULTISELECT',
            choices: region.reduce((r, el) => ({ ...r, [el]: el }), {}),
          },
        } : {}),
        ...(Array.isArray(district) && district.length ? {
          districts: {
            label: this.$t('campaign-admin.labels.districts'),
            type: 'MULTISELECT',
            choices: district.reduce((r, el) => ({ ...r, [el]: el }), {}),
          },
        } : {}),
        ...(!this.isChalhoub && Array.isArray(city) && city.length ? {
          cities: {
            label: this.$t('campaign-admin.labels.cities'),
            type: 'MULTISELECT',
            choices: city.reduce((r, el) => ({ ...r, [el]: el }), {}),
          },
        } : {}),
        ...(Array.isArray(country) && country.length ? {
          countries: {
            label: this.$t('campaign-admin.labels.countries'),
            type: 'MULTISELECT',
            choices: country.reduce((r, el) => ({ ...r, [el]: el }), {}),
          },
        } : {}),
        ...(Array.isArray(postalDistrict) && postalDistrict.length ? {
          postalDistricts: {
            label: this.$t('campaign-admin.labels.postalDistricts'),
            type: 'MULTISELECT',
            choices: postalDistrict.reduce((r, el) => ({ ...r, [el]: el }), {}),
          }
        } : {}),
        ...(Array.isArray(jobTitle) && jobTitle.length ? {
          jobTitles: {
            label: this.$t('campaign-admin.labels.titles'),
            type: 'MULTISELECT',
            choices: jobTitle.reduce((r, el) => ({ ...r, [el]: el }), {}),
          }
        } : {}),
        ...(Array.isArray(activity) && activity.length ? {
          activities: {
            label: this.$t('campaign-admin.labels.activities'),
            type: 'MULTISELECT',
            choices: activity.reduce((r, el) => ({ ...r, [el]: el }), {}),
          }
        } : {}),
        ...(Array.isArray(chain) && chain.length ? {
          chains: {
            label: this.$t('campaign-admin.labels.chains'),
            type: 'MULTISELECT',
            choices: chain.reduce((r, el) => ({ ...r, [el]: el }), {}),
          }
        } : {}),
        ...(Array.isArray(area) && area.length ? {
          areas: {
            label: this.$t('campaign-admin.labels.areas'),
            type: 'MULTISELECT',
            choices: area.reduce((r, el) => ({ ...r, [el]: el }), {}),
          }
        } : {}),
        ...(Array.isArray(company) && company.length ? {
          companies: {
            label: this.$t('campaign-admin.labels.companies'),
            type: 'MULTISELECT',
            choices: company.reduce((r, el) => ({ ...r, [el]: el }), {}),
          }
        } : {}),
        ...(Array.isArray(jobPosition) && jobPosition.length ? {
          jobPositions: {
            label: this.$t('campaign-admin.labels.jobPositions'),
            type: 'MULTISELECT',
            choices: jobPosition.reduce((r, el) => ({ ...r, [el]: el }), {}),
          }
        } : {}),
        ...(Array.isArray(callCenter) && callCenter.length ? {
          callCenters: {
            label: this.$t('campaign-admin.labels.callCenters'),
            type: 'MULTISELECT',
            choices: callCenter.reduce((r, el) => ({ ...r, [el]: el }), {}),
          }
        } : {}),
        ...(Array.isArray(office) && office.length ? {
          offices: {
            label: this.$t('campaign-admin.labels.offices'),
            type: 'MULTISELECT',
            choices: office.reduce((r, el) => ({ ...r, [el]: el }), {}),
          }
        } : {}),
        ...(Array.isArray(organisation) && organisation.length ? {
          organisations: {
            label: this.$t('campaign-admin.labels.organisations'),
            type: 'MULTISELECT',
            choices: organisation.reduce((r, el) => ({ ...r, [el]: el }), {}),
          }
        } : {}),
      };
    }
  },
  methods: {
    updateFilters() {
      const { returnSegment } = this;
      console.log(returnSegment);
      this.$emit('input', returnSegment);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/campaign-admin/CampaignAnalyticsFilterJob.vue